const symptomCategories = [
  {
    icon: 'ri-heart-pulse-line',
    title: 'Cardiovascular',
    color: 'bg-red-50 border-red-100',
    iconBg: 'bg-red-100',
    iconColor: 'text-red-600',
    symptoms: ['Valvular heart disease (mitral, aortic, pulmonary, tricuspid)','Septal defects (VSD, ASD, PFO)','Bicuspid aortic valve','Aortic arch abnormalities','Pulmonary artery stenosis','Dilated cardiomyopathy (DCM) — newly reported'],
  },
  {
    icon: 'ri-body-scan-line',
    title: 'Skeletal & Spinal',
    color: 'bg-brand-50 border-brand-100',
    iconBg: 'bg-brand-100',
    iconColor: 'text-brand-600',
    symptoms: ['Extensive posterior cervical vertebral fusion (synostosis)','Thoracic vertebral fusion — can inhibit lung growth','Scoliosis','Carpal and tarsal bone fusion','Brachydactyly (short fingers/toes)','Short stature / delayed bone age','Pectus excavatum','Joint laxity (hypermobility)','Elbow flexion contractures'],
  },
  {
    icon: 'ri-emotion-line',
    title: 'Craniofacial Features',
    color: 'bg-amber-50 border-amber-100',
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-600',
    symptoms: ['Prominent forehead with bitemporal narrowing','Hypertelorism (widely spaced eyes)','Downslanted palpebral fissures','Ptosis','Broad nasal bridge with anteverted nares','Long philtrum','Full cheeks','Low-set, posteriorly rotated ears','Strabismus','High, narrow palate'],
  },
  {
    icon: 'ri-volume-mute-line',
    title: 'Hearing & Ears',
    color: 'bg-accent-50 border-accent-100',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
    symptoms: ['Conductive hearing loss (bilateral)','Inner ear malformation','Stenosis of the external auditory canal','Recurrent otitis media','Tympanostomy tube procedures often required'],
  },
  {
    icon: 'ri-mental-health-line',
    title: 'Developmental',
    color: 'bg-gray-50 border-gray-200',
    iconBg: 'bg-gray-200',
    iconColor: 'text-gray-600',
    symptoms: ['Mild global developmental delay (gross and fine motor)','Speech delay','Hypotonia (low muscle tone)','Mild intellectual disability in some cases','Normal brain MRI in most cases reported'],
  },
  {
    icon: 'ri-store-3-line',
    title: 'Gastrointestinal',
    color: 'bg-orange-50 border-orange-100',
    iconBg: 'bg-orange-100',
    iconColor: 'text-orange-600',
    symptoms: ['Feeding difficulties from birth','Gastroesophageal reflux','Gastrointestinal dysmotility','Failure to thrive','Gastrostomy tube (G-tube) feeding in some cases','Intestinal obstruction — newly reported'],
  },
  {
    icon: 'ri-hand-coin-line',
    title: 'Skin & Integumentary',
    color: 'bg-yellow-50 border-yellow-100',
    iconBg: 'bg-yellow-100',
    iconColor: 'text-yellow-600',
    symptoms: ['Soft, velvety skin','Wrinkled skin of palms and soles','Skin laxity'],
  },
  {
    icon: 'ri-lungs-line',
    title: 'Pulmonary & Immune',
    color: 'bg-emerald-50 border-emerald-100',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-600',
    symptoms: ['Recurrent upper and lower respiratory infections','Pneumonia episodes','Respiratory dysfunction in severe cases','Possible immune dysregulation','Inflammatory bowel disease reported in one case'],
  },
];

export default function SymptomsSection() {
  return (
    <section id="symptoms" className="py-16 bg-gray-50">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 flex items-center justify-center bg-amber-50 rounded-xl">
            <i className="ri-list-check-2 text-amber-500 text-xl"></i>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 font-heading">Clinical Features & Symptoms</h2>
        </div>
        <p className="text-gray-500 text-sm mb-8 ml-14 leading-relaxed font-body">
          CSCFS can present differently in each individual. Not every person will have all features. Severity varies widely across reported cases.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {symptomCategories.map((cat) => (
            <div key={cat.title} className={`rounded-2xl border p-6 ${cat.color}`}>
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-9 h-9 flex items-center justify-center ${cat.iconBg} rounded-lg flex-shrink-0`}>
                  <i className={`${cat.icon} text-lg ${cat.iconColor}`}></i>
                </div>
                <h3 className="font-semibold text-gray-900 font-heading">{cat.title}</h3>
              </div>
              <ul className="space-y-1.5">
                {cat.symptoms.map((s, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-gray-600 font-body">
                    <i className="ri-checkbox-circle-line text-gray-400 mt-0.5 flex-shrink-0"></i>
                    <span>{s}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-6 text-xs text-gray-400 border-t border-gray-200 pt-4 font-body">
          Sources: AbuBakr et al. 2020; Nyuzuki et al. 2024; Das &amp; Criscuolo, <em>Ann Pediatr Cardiol</em> 2025; Yang et al., <em>Front Pediatr</em> 2025
        </div>
      </div>
    </section>
  );
}
